import { icon } from "leaflet";

export default [
  // {
  //   header: 'Cài đặt cấu hình',
  //   resource: 'setting',
  //   action: 'read',
  // },
  // {
  //   title: 'Loại tài khoản',
  //   route: 'role-list',
  //   icon: 'PocketIcon',
  //   resource: 'role',
  //   action: 'read',
  // },
  // {
  //   title: 'Người dùng',
  //   route: 'manager-list',
  //   icon: 'UsersIcon',
  //   resource: 'manager',
  //   action: 'read',
  // },
  // {
  //   title: 'Danh sách tài khoản',
  //   icon: 'CreditCardIcon',
  //   route: 'tingees',
  //   resource: 'bank',
  //   action: 'read',
  // },
  // {
  //   title: 'Mẫu in hóa đơn',
  //   icon: 'PrinterIcon',
  //   route: 'templates',
  //   resource: 'template',
  //   action: 'read',
  // },
  // {
  //   title: 'Mẫu in biên lai thu',
  //   icon: 'PrinterIcon',
  //   route: 'income-expense-templates',
  //   resource: 'template',
  //   action: 'read',
  // },
  // {
  //   title: 'Hoá đơn điện tử',
  //   icon: 'FileIcon',
  //   route: 'e-invoice',
  //   resource: 'general-setting',
  //   action: 'read'
  // },
  // {
  //   title: 'Cài đặt khác',
  //   icon: 'SettingsIcon',
  //   route: 'setting',
  //   resource: 'general-setting',
  //   action: 'read',
  // },

  //====================================================================================================================

  {
    header: 'Cài đặt',
    resource: 'setting',
    action: 'read',
  },
  {
    title: 'Danh sách tài khoản',
    icon: 'CreditCardIcon',
    route: 'tingees',
    resource: 'bank',
    action: 'read',
  },
  {
    title: 'Zalo OA',
    icon: 'MessageSquareIcon',
    route: 'zalo',
    resource: 'zalo',
    action: 'read',
  },
  {
    title: 'Mẫu in hóa đơn',
    icon: 'PrinterIcon',
    route: 'templates',
    resource: 'template',
    action: 'read',
  },
  {
    title: 'Mẫu in biên lai thu',
    icon: 'PrinterIcon',
    route: 'income-expense-templates',
    resource: 'template',
    action: 'read',
  },
  {
    title: 'Hoá đơn điện tử',
    icon: 'FileIcon',
    route: 'e-invoice',
    resource: 'general-setting',
    action: 'read',
  },
  {
    title: 'Cài đặt khác',
    icon: 'SettingsIcon',
    route: 'setting',
    resource: 'general-setting',
    action: 'read',
  },
];
